<script>
export default {};
</script>

<template>
  <!-- this div only exists to satisfy the `vue/valid-template-root` linter requirement -->
  <div />
</template>
